<template>
    <div class="section-box sent-post">
        <el-row class="row-bg">
            <el-col :span="12" style="text-align: left;line-height: 36px;">
                <el-button size="mini" :class="DataListType ==1 ?'selected':''" @click="chose(1)">正常展示</el-button>
                <el-button size="mini" style="margin-left: 25px;" :class="DataListType ==2 ?'selected':''" @click="chose(2)">仅作者可见</el-button>
                <el-button size="mini" style="margin-left: 25px;" :class="DataListType ==0 ?'selected':''" @click="chose(0)">已删除</el-button>
            </el-col>
            <el-col :span="12" style="text-align: right;">
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-col>
        </el-row>

        <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="666"
            border
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="帖子主题" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.Title" placeholder="输入关键字搜索" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.Title || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="帖子分类" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select 
                            size="mini" 
                            placeholder="请选择" 
                            v-model="form.CategoryId" 
                            style="width: 100%" 
                            filterable
                        >
                            <el-option 
                                v-for="(item, index) in postCategory.slice(1)" 
                                :value="item.Id" 
                                :label="item.CategoryName" 
                                :key="index"
                            ></el-option>
                    </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.CategoryName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发帖人Code">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.PosterUserCode" placeholder="输入关键字搜索" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.PosterUserCode || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发帖时间" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-date-picker 
                            size="mini" 
                            v-model="form.CreateTime" 
                            type="daterange" 
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" 
                            range-separator="—" 
                            start-placeholder="开始日期"
                            end-placeholder="结束日期" 
                            style="width: 100%">
                        </el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.CreateTime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="删除时间" v-if="form.DataListType == 0">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-date-picker 
                            size="mini" 
                            v-model="form.DeleteTime" 
                            type="daterange" 
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" 
                            range-separator="—" 
                            start-placeholder="开始日期"
                            end-placeholder="结束日期" 
                            style="width: 100%">
                        </el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.DeleteTime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="删除人" v-if="form.DataListType == 0">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.DeleteUser" placeholder="输入关键字搜索" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.DeleteUser || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="详情" >
                <template slot-scope="scope">
                    <el-button size="mini" @click="checkPostDetail(scope.row.Id)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageIndex"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { 
  getStorageToken,
} from '@/utils/store'
import {
    getListPublishedPost,       //获取已发列表
    GetPostCategory,            //获取帖子分类
} from "@/service/run";
  export default {
    data() {
        return {
            listLoading: false,
            form: {
                PageIndex: 1,
                PageSize: 10,
                Title: '',              //帖子主题
                CategoryId: '',         //帖子分类id
                PosterUserCode: '',     //发帖人code
                CreateTime: [],         //创建时间
                DeleteTime: [],         //删除时间
                DeleteUser: '',         //删除人
            },
            DataListType: 1,        //数据列表类型 -1全部 1正常展示 0已删除
            searchData:{},
            oraginForm:{},
            total: 0,                       //总条数
            tableData:[],
            postCategory: [],               //帖子分类
        }
    },
    activated(){},
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
        this.handleSearch()
        this.getPostCategory();
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        // 获取帖子分类
        getPostCategory(){
            GetPostCategory().then(res=> {
                this.postCategory = res.Data
            })
        },
        // table切换 
        chose(type){
            this.DataListType = type;
            this.handleSearch()
        },
        //渲染列表
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.handleCurrentChange(1)
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.PageIndex = val
            this.searchData.PageIndex = val
            this.GetListPublishedPost()
        },
        //翻页
        handleSizeChange(val) {
        if (this.listLoading) return
            this.form.PageIndex = 1
            this.form.PageSize = val
            this.searchData.PageIndex = 1
            this.searchData.PageSize = val
            this.GetListPublishedPost()
        },
        async GetListPublishedPost(){
            this.listLoading = true
            let data = JSON.parse(JSON.stringify(this.searchData))
            !data.Title && delete data.Title
            !data.CategoryId && delete data.CategoryId
            !data.PosterUserCode && delete data.PosterUserCode
            if (data.CreateTime && data.CreateTime.length) {
                data.CreateStartTime = data.CreateTime[0]
                data.CreateEndTime = data.CreateTime[1]
            }
            if (data.DeleteTime && data.DeleteTime.length) {
                data.DeleteStartTime = data.DeleteTime[0]
                data.DeleteEndTime = data.DeleteTime[1]
            }
            delete data.CreateTime
            delete data.DeleteTime
            data.DataListType = this.DataListType
            let res = await getListPublishedPost(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }
            this.tableData = res.Data.List
            this.total = res.Data.TotalRows
        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()
        },
        // 点击跳转详情
        checkPostDetail(id) {
            this.$router.push(`/run/sentPostDetail?id=${id}`);
        },
    }
  }
</script>

<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
    .sent-post {
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
</style>